module.exports = __webpack_public_path__ + "5ea89a1325355f913841f1277e5d1982.svg";